import { render, staticRenderFns } from "./appBillingAddress.vue?vue&type=template&id=12fd0156&"
import script from "./appBillingAddress.vue?vue&type=script&lang=js&"
export * from "./appBillingAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports